{
  "nav": {
    "tools": "Outils",
    "openMenu": "Ouvrir le menu",
    "subscription": "Abonnement",
    "configuration": "Configuration",
    "account": "Compte",
    "administration": "Administration",
    "ourTools": "Nos outils",
    "pricing": "Tarifs",
    "faq": "FAQ"
  },
  "toolItems": {
    "flippingTool": "Outil de flipping",
    "dropshipTool": "Outil de dropship",
    "housingTool": "Outil de housing",
    "inventoryAnalysisTool": "Outil d'analyse d'inventaire",
    "snipeAlerts": "Alertes snipe",
    "realmStats": "Statistiques de royaume",
    "tsmListGenerator": "Générateur de liste TSM",
    "tsmProfileSetupGuide": "Guide de configuration du profil TSM",
    "dashboard": "Tableau de bord",
    "classicDeals": "Classic Deals"
  },
  "configItems": {
    "regionRealm": "Configuration région & royaume",
    "personal": "Configuration personnelle",
    "discord": "Configuration Discord"
  },
  "accountItems": {
    "settings": "Paramètres"
  },
  "adminItems": {
    "stats": "Statistiques",
    "userInfo": "Informations utilisateur",
    "goldSubscription": "Abonnement or",
    "itemLookup": "Recherche d'objet",
    "snipeAudit": "Audit de snipe",
    "emailPreviews": "Aperçu des e-mails"
  },
  "buttons": {
    "login": "Connexion",
    "logout": "Déconnexion",
    "register": "S'inscrire",
    "registerNow": "S'inscrire maintenant",
    "signIn": "Se connecter",
    "tryAgain": "Réessayer",
    "goBack": "Retour",
    "cancel": "Annuler",
    "deactivate": "Désactiver",
    "upgrade": "Mettre à niveau",
    "upgradeToPremium": "Passer au Premium",
    "upgradeNow": "Mettre à niveau maintenant",
    "unlockPremiumFeatures": "Débloquer les fonctionnalités Premium",
    "getMoreResultsAndFilters": "Obtenir plus de résultats et de filtres",
    "goToConfig": "Aller à la configuration",
    "save": "Save",
    "close": "Fermer",
    "actions": "Actions",
    "copyToClipboard": "Copier dans le presse-papiers",
    "saving": "Enregistrement…"
  },
  "loading": {
    "pleaseWait": "Veuillez patienter",
    "important": "Important",
    "defaultWarning": "Veuillez ne pas recharger la page pendant ce processus.",
    "progressComplete": "{{percent}}% terminé",
    "loadingAriaLabel": "Chargement",
    "loadingProgressAriaLabel": "Progression du chargement : {{percent}}%"
  },
  "error": {
    "somethingWentWrong": "Une erreur s'est produite",
    "defaultMessage": "Une erreur est survenue ! Attendez quelques secondes et rechargez la page",
    "fetchDataFailed": "Échec du chargement des données d'hôtel des ventes"
  },
  "cancelDialog": {
    "title": "Annuler l'abonnement",
    "confirmQuestion": "Êtes-vous sûr de vouloir annuler votre abonnement ?",
    "loseAccessNotice": "Vous perdrez l'accès aux outils et ne serez plus facturé pour les prochains paiements.",
    "warning": "Avertissement : Une fois votre abonnement annulé, vous perdrez l'accès aux outils à la fin de votre accès payant et nous ne rembourserons pas les abonnements annulés."
  },
  "dialog": {
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "realmLimitPopup": {
    "title": "Limite de royaumes dépassée",
    "description": "Vous avez sélectionné plus de royaumes de vente que l'abonnement de base ne le permet. Veuillez modifier votre configuration ou passer au premium."
  },
  "tooltipOverlay": {
    "upgradeTitle": "Passer au Premium",
    "upgradeSubtitle": "Exploitez toute la puissance de Flipping Pal",
    "enhancedFeatures": "Fonctionnalités améliorées",
    "exclusiveFeatures": "Fonctionnalités Premium exclusives",
    "alsoIncluded": "Également inclus"
  },
  "footer": {
    "changelog": "Journal des modifications"
  },
  "logoAlt": "Flipping Pal - votre site de flipping WoW préféré",
  "toggleNavAriaLabel": "Basculer le menu de navigation",
  "mainNavAriaLabel": "Navigation principale",
  "toolNavAriaLabel": "Navigation des outils",
  "simpleNavAriaLabel": "Navigation simple",
  "footerNavAriaLabel": "Navigation du pied de page",
  "clipboard": {
    "copied": "Copié dans le presse-papiers !",
    "tsmCopied": "Chaîne TSM copiée dans le presse-papiers !",
    "exportCopied": "Code d'exportation copié avec succès dans le presse-papiers.",
    "auctionatorCopied": "Listes d'achats Auctionator copiées dans le presse-papiers !",
    "titleCopied": "{{title}} copié dans le presse-papiers !",
    "copyFailed": "Échec de la copie dans le presse-papiers"
  },
  "favorites": {
    "added": "Ajouté aux favoris",
    "removed": "Retiré des favoris"
  },
  "enabled": "activé",
  "disabled": "désactivé",
  "dataRefreshed": "Données actualisées ! {{count}} opportunités trouvées.",
  "notFound": {
    "title": "Page introuvable"
  },
  "paymentSuccess": {
    "title": "Paiement réussi"
  },
  "pagination": {
    "summary": "Nombre total d'articles trouvés : {{total}} | Résultats par page : {{perPage}}",
    "summaryWithPages": "Nombre total d'articles trouvés : {{total}} | Résultats par page : {{perPage}} | Nombre total de pages : {{pages}}",
    "label": "Pagination",
    "firstPage": "Première page",
    "previousPage": "Page précédente",
    "nextPage": "Page suivante",
    "lastPage": "Dernière page",
    "pageAriaLabel": "Page {{page}}"
  },
  "stats": {
    "totalInvestment": "Investissement total",
    "estimatedSellPrice": "Prix de vente estimé",
    "profitAfterAHCut": "Bénéfice après la commission de l'HV"
  },
  "filters": {
    "searchItems": "Rechercher des articles...",
    "watchVideoGuide": "Voir le guide vidéo",
    "watchVideoIntro": "Voir la vidéo d'introduction",
    "crossRealmVideoGuide": "Guide vidéo de l'outil de flipping inter-royaume",
    "dropshipVideoGuide": "Guide vidéo de l'outil de flipping dropship",
    "housingVideoGuide": "Guide vidéo de l'outil housing",
    "downloadXLSX": "Télécharger les données en XLSX",
    "getAuctionatorLists": "Obtenir les listes Auctionator",
    "quality": "Qualité",
    "selectQuality": "Sélectionner la qualité",
    "qualities": "qualités",
    "expansions": "Extensions",
    "selectExpansions": "Sélectionner les extensions",
    "expansionsMultiple": "extensions",
    "sellingRealms": "Royaumes de vente",
    "selectSellingRealms": "Sélectionner les royaumes de vente",
    "sellingRealmsMultiple": "royaumes de vente",
    "buyingRealms": "Royaumes d'achat",
    "selectBuyingRealms": "Sélectionner les royaumes d'achat",
    "buyingRealmsMultiple": "royaumes d'achat",
    "categories": "Catégories",
    "selectCategories": "Sélectionner les catégories",
    "categoriesMultiple": "catégories",
    "sellRate": "Taux de vente",
    "saleAvg": "Moyenne des ventes",
    "haveCraftedItems": "Articles fabriqués",
    "profitOnSaleAvg": "Bénéfice sur la moyenne des ventes",
    "saleAvgVsBuyPercent": "Moyenne des ventes vs achat %",
    "profitSellVsBuy": "Bénéfice (vente vs achat)",
    "profitPercent": "Bénéfice %",
    "maxGoldBuyout": "Achat direct max en or",
    "ilvl": "Niv. objet",
    "activateProfitOnSaleAvg": "Activer le bénéfice sur la moyenne des ventes",
    "regionMarketValue": "Valeur marchande régionale",
    "regionHistorical": "Valeur historique régionale",
    "modeRecalculate": "Recalculer",
    "modeFilter": "Filtrer",
    "modeRecalculateHint": "Les changements de filtre recalculent les résultats sur le serveur",
    "modeFilterHint": "Les changements de filtre affinent uniquement les résultats déjà chargés",
    "modeAria": "Comportement lors d'un changement de filtre",
    "modeLabel": "Au changement de filtre"
  },
  "table": {
    "noData": "Aucune donnée trouvée",
    "sellVsBuyTooltip": "La commission de 5% de l'hôtel des ventes est prise en compte dans le calcul du bénéfice",
    "toggleAllFavorites": "Basculer tous les favoris",
    "clickToCopy": "Cliquer pour copier : {{name}}",
    "priceAfterAHCut": "Prix après commission HV : {{price}}",
    "noCompetition": "Pas de concurrence",
    "noCompetitionTooltip": "Aucune annonce connue sur le royaume de vente.",
    "population": "Population : {{population}}",
    "viewOnWowhead": "Voir {{name}} sur Wowhead",
    "addToFavorites": "Ajouter aux favoris",
    "removeFromFavorites": "Retirer des favoris",
    "sessionExpiredFavorite": "Session expirée. Veuillez vous reconnecter.",
    "failedToUpdateFavorite": "Impossible de mettre à jour le favori",
    "addSnipeAlert": "Ajouter une alerte snipe",
    "editSnipeAlert": "Modifier l'alerte snipe",
    "headers": {
      "itemName": "Nom de l'objet",
      "category": "Catégorie",
      "ilvl": "ilvl",
      "sellRate": "Taux de vente",
      "expansion": "Extension",
      "quality": "Qualité",
      "extraStats": "Stats supp.",
      "saleAvg": "Vente moy.",
      "regionMarketValue": "VM région",
      "saleAvgVsBuy": "Vente moy. vs Achat",
      "sellVsBuy": "Vente vs Achat",
      "sellPrice": "Prix de vente",
      "sellRealm": "Royaume de vente",
      "buyPrice": "Prix d'achat",
      "buyRealm": "Royaume d'achat"
    },
    "columnsTitle": "Colonnes",
    "columnsReset": "Réinitialiser",
    "columnsDragToReorder": "Glisser pour réordonner",
    "columnsToggleVisibility": "Cliquer sur l'œil pour basculer la visibilité",
    "columnSettings": "Paramètres des colonnes",
    "dragReorder": "Glisser pour réordonner {{column}}",
    "hideColumn": "Masquer {{column}}",
    "showColumn": "Afficher {{column}}",
    "rowActions": "Actions de la ligne",
    "actions": {
      "selectionSection": "Sélection",
      "pinSection": "Épingler en haut",
      "selectPage": "Sélectionner la page",
      "deselectPage": "Désélectionner la page",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "sortFavorites": "Épingler les favoris",
      "sortSnipes": "Épingler les alertes de snipe",
      "sortSelected": "Épingler la sélection",
      "columnSettings": "Paramètres des colonnes..."
    },
    "sortHint": "Cliquez pour trier",
    "sortHintMulti": "Cliquez pour trier · Maj+clic pour un tri secondaire",
    "selectRow": "Sélectionner {{name}}",
    "emptyFiltered": "Aucun objet ne correspond à vos filtres actuels",
    "emptyResetFilters": "Réinitialiser les filtres",
    "emptyUpdating": "Une mise à jour de la région est en cours — les nouvelles données arriveront bientôt."
  },
  "multipleSelect": {
    "noResults": "Aucun résultat trouvé",
    "selectAll": "Tout sélectionner",
    "clearAll": "Tout effacer",
    "selectOption": "Sélectionner une option",
    "selectMultipleOptions": "Sélectionner plusieurs options",
    "selected": "sélectionné(s)",
    "searchOptions": "Rechercher des options",
    "noItemsSelected": "Aucun élément sélectionné",
    "search": "Rechercher...",
    "items": "éléments"
  },
  "hierarchicalSelect": {
    "selectAll": "Tout sélectionner",
    "clearAll": "Tout effacer",
    "expand": "Développer",
    "collapse": "Réduire",
    "selected": "sélectionné(s)",
    "noItemsSelected": "Sélectionner des catégories...",
    "items": "catégories",
    "triggerAriaLabel": "Sélectionner {{items}}. {{count}} sélectionnés."
  },
  "hoverChart": {
    "high": "Haut :",
    "low": "Bas :",
    "avg": "Moy. :"
  },
  "tokenDisplay": {
    "label": "Jeton WoW",
    "signalBuy": "Signal d'achat — le prix est actuellement favorable",
    "signalWait": "Attendre — le prix devrait continuer à baisser",
    "signalHold": "Conserver — pas de tendance claire pour le moment",
    "loading": "Chargement...",
    "error": "Erreur",
    "priceHistory": "Historique des prix sur 14 jours",
    "high": "Haut : ",
    "low": "Bas : ",
    "avg": "Moy. : ",
    "momentum": "Dynamique",
    "slowing": "Ralentissement ({{steps}})",
    "atCap": "Au plafond de 1%",
    "steps": "{{count}} étape",
    "stepsPlural": "{{count}} étapes"
  },
  "nextUpdate": {
    "nextDataUpdate": "Prochaine mise à jour des données",
    "dataSourceStatus": "Statut des sources de données",
    "tsmData": "Données TSM :",
    "blizzardRealm": "Royaume Blizzard :",
    "liveUpdates": "Mises à jour en direct :",
    "connected": "Connecté",
    "reconnecting": "Reconnexion...",
    "retry": "Réessayer",
    "autoRefresh": "Actualisation auto :",
    "autoRefreshEnabled": "La page s’actualisera automatiquement lorsque de nouvelles données seront disponibles",
    "autoRefreshDisabled": "Cliquez sur l'icône d'actualisation lorsque de nouvelles données sont prêtes",
    "loadingStatus": "Chargement du statut des données...",
    "viewStatus": "Voir le statut des sources de données",
    "refreshData": "Actualiser les données",
    "reloading": "Rechargement",
    "liveUpdatesConnected": "Mises à jour en direct connectées",
    "liveUpdatesReconnecting": "Reconnexion...",
    "tsmFresh": "Données TSM à jour (< 24h)",
    "tsmStale24": "Données TSM bientôt obsolètes (24-25h)",
    "tsmStale25": "Données TSM obsolètes (> 25h)",
    "toggleAutoRefresh": "Basculer l'actualisation automatique"
  },
  "regionUpdateProgress": {
    "updating": "Mise à jour des données régionales",
    "realmsProgress": "{{updated}}/{{total}} royaumes ({{percent}}%)",
    "autoRefresh": "Les données s'actualiseront automatiquement lorsqu'elles seront prêtes",
    "reloadPartial": "Données partielles disponibles — charger maintenant"
  },
  "filterFlyout": {
    "filtersButton": "Filtres",
    "loadingPresets": "Chargement...",
    "selectPreset": "Sélectionner un préréglage...",
    "presetsSection": "Préréglages",
    "save": "Enregistrer",
    "update": "Mettre à jour",
    "delete": "Supprimer",
    "export": "Exporter",
    "import": "Importer",
    "importPreset": "Importer un préréglage…",
    "presetNamePlaceholder": "Nom du préréglage...",
    "shareCode": "Partager ce code :",
    "copy": "Copier",
    "done": "Terminé",
    "pasteCodePlaceholder": "Coller le code ici...",
    "applyFilters": "Appliquer les filtres",
    "resetFilters": "Réinitialiser les filtres",
    "refreshNow": "Actualiser maintenant",
    "reset": "Réinitialiser",
    "deletePresetTitle": "Supprimer le préréglage",
    "deletePresetMessage": "Voulez-vous vraiment supprimer ce préréglage ? Cette action est irréversible."
  },
  "discord": {
    "title": "Intégration Discord",
    "description": "Liez votre compte Discord pour recevoir des notifications personnalisées et des mises à jour de notre bot.",
    "accountLinked": "Compte Discord lié",
    "connectedAs": "Connecté en tant que :",
    "unlink": "Dissocier",
    "dmVerifiedBadge": "DMs vérifiés : Votre Discord peut recevoir des notifications de notre bot.",
    "dmVerificationTitle": "Vérification des DMs requise",
    "dmVerificationDesc": "Pour activer les notifications, nous devons confirmer que notre bot peut vous envoyer des messages directs. Assurez-vous d'avoir les DMs activés pour au moins un serveur que vous partagez avec notre bot.",
    "sendVerificationCode": "Envoyer le code de vérification à mon Discord",
    "sendingCode": "Envoi du code...",
    "codeSentInstructions": "Vérifiez vos DMs Discord pour un code à 6 chiffres de notre bot. Si vous n'avez pas reçu de DM, vérifiez dans vos paramètres sous Contenu & Social > Permissions sociales que les messages directs sont activés.",
    "enterCodePlaceholder": "Entrer le code à 6 chiffres",
    "verify": "Vérifier",
    "resendCode": "Renvoyer le code",
    "notificationSettings": "Paramètres de notification",
    "verifyDmsFirst": "(vérifiez les DMs d'abord)",
    "botFeaturesAvailable": "Fonctionnalités du bot disponibles : Vous pouvez maintenant recevoir des messages privés pour les mises à jour de région, les snipes d'objets & familiers, les snipes iLvl BoE et le prix du jeton WoW.",
    "notConnected": "Non connecté : Liez votre compte Discord pour activer les notifications et fonctionnalités du bot.",
    "connectingToDiscord": "Connexion à Discord...",
    "linkAccount": "Lier le compte Discord",
    "regionUpdateLabel": "Notifications de mise à jour de région",
    "regionUpdateDesc": "Recevoir des notifications lorsque les données des enchères sont mises à jour pour vos régions sélectionnées.",
    "sendTestDm": "Envoyer un MP de test",
    "sendingTest": "Envoi…",
    "sendTestWebhook": "Tester",
    "testMessageHint": "Envoyez un message test pour vérifier la livraison Discord sans attendre un véritable snipe.",
    "categoriesTitle": "Catégories de notifications",
    "categoriesDesc": "Acheminez les alertes de snipe vers différents salons Discord. Chaque catégorie a sa propre URL de webhook et son propre mode de mention.",
    "categoriesPremiumHint": "Les catégories supplémentaires nécessitent un abonnement premium.",
    "categoryNamePlaceholder": "Nom de la catégorie",
    "webhookUrlPlaceholder": "https://discord.com/api/webhooks/...",
    "mentionLabel": "Mention :",
    "defaultLabel": "Par défaut",
    "defaultCategoryTitle": "Catégorie par défaut",
    "noWebhookSet": "aucun webhook défini",
    "setAsDefault": "Définir par défaut",
    "edit": "Modifier",
    "delete": "Supprimer",
    "add": "Ajouter",
    "addCategory": "+ Ajouter une catégorie",
    "deleteCategoryTitle": "Supprimer la catégorie",
    "deleteCategoryMessage": "Voulez-vous vraiment supprimer la catégorie « {{name}} » ? Les alertes qui lui sont assignées utiliseront votre catégorie par défaut."
  },
  "csvExport": {
    "title": "Export CSV",
    "noItems": "Aucun élément disponible.",
    "copy": "Copier dans le presse-papiers",
    "copied": "CSV copié dans le presse-papiers !",
    "copyFailed": "Échec de la copie",
    "download": "Télécharger le CSV"
  },
  "updateBanner": {
    "title": "Mise à jour disponible",
    "description": "Une nouvelle version est prête.",
    "reload": "Recharger",
    "dismiss": "Ignorer"
  },
  "premiumPreviewBanner": {
    "title": "Vous bénéficiez de l'accès Premium complet",
    "dayLeftOne": "1 jour restant",
    "daysLeft": "{{count}} jours restants",
    "dismiss": "Ignorer"
  },
  "tour": {
    "start": "Démarrer la visite de cette page"
  },
  "filterSidebar": {
    "profitRange": "Plage de profit",
    "crafted_include": "Tous les objets",
    "crafted_excluded": "Exclure les crafts",
    "crafted_exclusive": "Seulement les crafts",
    "showPositiveSaleAvgVsBuy": "Seulement vente moyenne positive vs achat",
    "presetClickToDeselect": "Cliquer pour désélectionner le préréglage",
    "collapseSidebar": "Réduire les filtres",
    "expandSidebar": "Développer les filtres"
  },
  "dashboard": {
    "loadError": "Impossible de charger les données du tableau de bord. Vérifiez votre connexion et réessayez.",
    "greeting": {
      "morning": "Bonjour",
      "afternoon": "Bon après-midi",
      "evening": "Bonsoir"
    },
    "subtitle": "Voici ce qui se passe sur l'hôtel des ventes aujourd'hui.",
    "kpi": {
      "opportunities": "Opportunités"
    },
    "topOpportunities": {
      "title": "Meilleures opportunités",
      "viewAll": "Voir tout",
      "itemsFound": "objets trouvés sur",
      "realms": "royaumes",
      "openTool": "Ouvrir l'outil de flipping",
      "ilvl": "ilvl",
      "sellRate": "taux de vente",
      "tabFastSelling": "Fast Selling",
      "tabTopBuys": "Top Buys",
      "sellRateMin": "Sell Rate ≥",
      "buyBelowPct": "Buy Below",
      "noItems": "No items match the current filters",
      "saveFailed": "Impossible d'enregistrer les paramètres. La dernière valeur enregistrée a été restaurée.",
      "saved": "Enregistré",
      "sellRateTooltip": "Le taux de vente est sur une échelle de 0 à 1 : la part des enchères publiées qui se vendent réellement chaque jour. 0,1 ≈ 10 % des annonces."
    },
    "recentSnipes": {
      "title": "Snipes récents",
      "monitoringRealms": "Surveillance de {{count}} royaumes",
      "vsTarget": "vs cible",
      "itemsMonitored": "objets surveillés",
      "configureAlerts": "Configurer les alertes",
      "noSnipes": "Aucun snipe détecté ce cycle",
      "saved": "économisé"
    },
    "topRealms": {
      "title": "Top Realms",
      "sortPopVsAuctions": "Population vs Auctions",
      "sortPriceRatio": "Price Ratio",
      "sortNumAuctions": "Number of Auctions",
      "viewRealmStats": "Voir les stats des royaumes"
    },
    "quickAccess": {
      "title": "Accès rapide"
    },
    "onboarding": {
      "title": "Premiers pas",
      "progress": "{{done}}/{{total}} terminées",
      "hide": "Masquer la liste",
      "steps": {
        "realms": "Configurer vos royaumes",
        "preset": "Créer un préréglage de filtres de départ",
        "flipping": "Lancer votre premier scan de flipping",
        "discordLink": "Lier votre compte Discord",
        "snipe": "Configurer les alertes de snipe",
        "discordJoin": "Rejoindre le serveur Discord"
      },
      "createPreset": "Créer le préréglage",
      "creatingPreset": "Création…",
      "starterPresetName": "Démarrage",
      "configureRealmsFirst": "Configurez d'abord vos royaumes pour créer un préréglage",
      "presetLimitReached": "Vous avez atteint votre limite de préréglages enregistrés",
      "createPresetFailed": "Impossible de créer le préréglage. Veuillez réessayer."
    },
    "activity": {
      "title": "Activité",
      "timeAgoLess1m": "<1m",
      "timeAgoMinutes": "il y a {{count}}m",
      "timeAgoHours": "il y a {{count}}h",
      "dataRefreshed": "Données actualisées — {{n}} opportunités trouvées",
      "realmDataUpdated": "Données des royaumes {{region}} mises à jour",
      "waitingForData": "En attente de la première actualisation…",
      "snipeAlertsActive": "Les alertes de snipe sont actives et surveillent vos royaumes",
      "tokenTracked": "Le prix du WoW Token est suivi toutes les 20 minutes"
    }
  },
  "versionSwitcher": {
    "label": "Game version",
    "retail": "Retail",
    "classicEra": "Classic Era",
    "switchFailed": "Failed to switch game version"
  },
  "classicDeals": {
    "title": "Classic Deals",
    "subtitle": "Buy items listed far below the next-cheapest copy on the same realm, then relist for a profit.",
    "region": "Region",
    "realms": "Realms",
    "selectRealms": "Select realms",
    "realmsSelected": "realms selected",
    "saveRealms": "Save realms",
    "findDeals": "Find deals",
    "loading": "Loading…",
    "selectRealmFirst": "Select at least one realm first",
    "saveFailed": "Failed to save realms",
    "realmsSaved": "Realms saved",
    "fetchFailed": "Failed to load deals",
    "noDeals": "No deals found for the selected realms.",
    "emptyPrompt": "Select your realms and click Find deals.",
    "colItem": "Item",
    "colRealm": "Realm",
    "colLowest": "Lowest",
    "colNext": "Next",
    "colProfit": "Profit",
    "colGap": "Gap",
    "colQty": "Qty",
    "colSaleRate": "Sale rate"
  },
  "backToTop": "Retour en haut",
  "slider": {
    "min": "Min",
    "max": "Max",
    "minAriaLabel": "Valeur minimale",
    "maxAriaLabel": "Valeur maximale",
    "numericInput": "Saisie numérique {{label}}"
  },
  "inputBox": {
    "clear": "Effacer la saisie",
    "required": "obligatoire"
  },
  "auctionator": {
    "title": "Listes d'achats Auctionator",
    "account": "Compte :",
    "allAccounts": "Tous les comptes",
    "noItems": "Aucun objet disponible pour le compte sélectionné."
  },
  "popup": {
    "getTitle": "Obtenir {{title}}",
    "content": "Contenu",
    "noContent": "Aucun contenu disponible",
    "copyTitle": "Copier {{title}}",
    "copyContent": "Copier le contenu",
    "titleContent": "Contenu de {{title}}",
    "videoContent": "Contenu vidéo",
    "videoNotSupported": "Votre navigateur ne prend pas en charge la balise vidéo."
  },
  "snipePopup": {
    "ariaLabel": "Alerte snipe pour {{name}}",
    "titleItem": "Alerte snipe d'objet",
    "titlePet": "Alerte snipe de mascotte",
    "maxBuyoutPrice": "Prix d'achat immédiat maximum",
    "pricePlaceholder": "ex. 500g ou 500g 50s",
    "saving": "Enregistrement...",
    "updateAlert": "Mettre à jour l'alerte",
    "setAlert": "Définir l'alerte"
  },
  "refreshingData": "Actualisation des données...",
  "toolAccess": {
    "subscriptionRequired": "Vous avez besoin d'un abonnement actif pour utiliser cet outil !",
    "premiumRequired": "Vous avez besoin d'un abonnement premium actif pour utiliser cet outil !"
  }
}
